import formControl from "./formControl";
// 公式审核状态组件  基类   包含了pc 和移动端  修改需谨慎 ！！！！
export default {
  mixins: [formControl],
  props: {
    caption: {
      type: String,
      default: "audit_state",
    },
    label: {
      type: String,
      default: "审核状态",
    },
    // 元数据
    metadata: {
      type: Object,
      default() {
        let md = dsf.metadata.get("big-text-meta-data");
        return md;
      },
    },
    // 触发方式  watch 监听自动弹出 manual 手动触发
    triggerType: {
      default: "watch",
    },
    visible: {
      default: false,
    },
    // 是否使用远程校验
    openService: {
      default: true,
    },
    customEvJsPath: {
      default: "",
    },
  },
  data() {
    return {
      drawerOpen: false,
      // 强制型
      mandatoryErrorList: [],
      // 核实型
      verifyErrorList: [],
      // 忽略型
      ignoreErrorList: [],
      // js公式
      jsFormulaList: [],
    };
  },
  computed: {
    showSaveBtn() {
      return this.verifyErrorList.length || this.ignoreErrorList.length;
    },
    showOpenBtn() {
      return (
        this.mandatoryErrorList.length ||
        this.verifyErrorList.length ||
        this.ignoreErrorList.length
      );
    },
    isVisible() {
      return this.isDesign || (!this.isDesign && this.visible);
    },
    metadataDict() {
      return this.$vm?.metadataDict || {};
    },
    jsFormulaLsitMap() {
      let map = {};
      this.jsFormulaList.forEach((item) => {
        item.fields.forEach((field) => {
          if (!map[field]) {
            map[field] = [];
          }
          map[field].push(item);
        });
      });
      return map;
    },
    verifyErrorListMap() {
      const map = {};
      this.verifyErrorList.forEach((item) => {
        map[item?.info?.formula?.id] = item;
      });
      return map;
    },
  },
  watch: {
    "$vm.$isReady": {
      handler(v) {
        if (v) {
          this.initValue(this.value)
        }
      }
    }
  },
  methods: {
    initValue(v) {
      if (this.isInitValue || !this.$vm?.queryString?.id) return;
      this.isInitValue = true;
      console.log('初始化');
      try {
        let obj = JSON.parse(v);
        if (dsf.isObject(obj)) {
          if (obj.verifyErrorList.length) {
            obj.verifyErrorList.forEach((ite) => {
              this.$vm.pushError(
                new window.$$ValidateError(ite.message, ite.target, ite.info)
              );
              this.verifyErrorList.push(ite);
            });
          }
          if (obj.ignoreErrorList.length) {
            obj.ignoreErrorList.forEach((ite) => {
              this.$vm.pushError(
                new window.$$ValidateError(ite.message, ite.target, ite.info)
              );
              this.ignoreErrorList.push(ite);
            });
          }
          if (obj.mandatoryErrorList.length) {
            obj.mandatoryErrorList.forEach((ite) => {
              this.$vm.pushError(
                new window.$$ValidateError(ite.message, ite.target, ite.info)
              );
              this.mandatoryErrorList.push(ite);
            });
          }
        }
      } catch (error) {
        // console.error(errr);
      }
    },
    getFormulaVerifyFn(key, val, dict, formName, data, meta) {
      let list = [];
      try {
        if (this.jsFormulaLsitMap[key]?.length) {
          this.jsFormulaLsitMap[key].forEach((item) => {
            const mandatoryType = item.mandatoryType?.value;
            // eslint-disable-next-line no-async-promise-executor
            list.push(() => new Promise(async (resolve) => {
              let errors = [];
              let cloneMeta = { ...meta };
              delete cloneMeta.refs;
              const $viewData = _.cloneDeep(this.$vm.$viewData)
              const $formulaArgs = _.cloneDeep(this.$vm.$formulaArgs)
              const keys = key?.split('.')
              let tableName;
              let code;
              if (keys?.length) {
                tableName = keys[0]
                code = keys[1]
              }
              const sandboxParams = {
                $this: this,
                $main: $viewData,
                $viewData: $viewData,
                $tableName: tableName,
                $code: code,
                $key: key,
                $val: val,
                $formulaArgs,
                $args: {
                },
              };
              if (meta.inSubTable || meta.level == 1) {
                sandboxParams.$row = _.cloneDeep(data);
                sandboxParams.$index = sandboxParams?.$row?.$index;
              }
              let status = true;
              if (dsf.isFunction(item.verify)) {
                status = await item.verify.call(this.$vm, sandboxParams);
              } else if (dsf.isFunction(item.contentJs)) {
                status = await item.contentJs.call(
                  this.$vm,
                  sandboxParams,
                );
              } else {
                status = await new Function(
                  "sandboxParams",
                  `with (sandboxParams) {
                    ${item.contentJs}
                  }`
                ).call(
                  this.$vm,
                  sandboxParams,
                );
              }
              if (dsf.isObject(status) || !status) {
                const opt = {
                  formula: item,
                  mandatoryType: mandatoryType,
                  mandatoryTypeText: item.mandatoryType?.text,
                  ignore:
                    mandatoryType == 4 ||
                    (mandatoryType == 3 &&
                      this.verifyErrorListMap[item.id]?.remark), // 忽略型
                }
                let message = item.message
                if (dsf.isObject(status)) {
                  if ('message' in status) {
                    message = status.message
                  }
                }
                errors.push(
                  new window.$$ValidateError(message, formName, opt)
                );
              }
              if (!errors.length) {
                this.jsFormulaLsitMap[key].forEach((jsFormula) => {
                  jsFormula.fields.forEach((key) => {
                    this.removeRelationErrors(key, jsFormula)
                  })
                })
              }
              resolve(errors)
            }));
          });
        }
      } catch (error) {
        console.error('验证错误', error);
      }
      return list;
    },
    removeRelationErrors(key, jsFormula) {
      let vmErrors = this.$vm.$errors
      for (const errorkey in vmErrors) {
        if (new RegExp(`^${key}`).test(errorkey)) {
          vmErrors[errorkey].forEach((ite) => {
            if (ite?.info?.formula?.id && jsFormula.id == ite?.info?.formula?.id) {
              this.$vm.removeErrorsByTarget(ite.target)
            }
          })
        }
      }
    },
    checkIsError() {
      let $errors = this.$vm.$errors
      let isTip = 0
      let isIgnoreNum = 0
      let isMandatory = 0
      for (const key in $errors) {
        let list = $errors[key] || []
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          if (item.info.mandatoryType == 4) {
            isTip = 1
          }
          if (!item.info.ignore) {
            if (item.info.mandatoryType == 3) {
              isIgnoreNum = 1
            }
            isMandatory = 1
          }
        }
      }
      if (isTip) return 1 // 忽略性错误
      if (isIgnoreNum) return 2 // 有忽略性错误未处理
      if (isMandatory) return 3 // 强制性
      return 0 // 正确
    },
    async formulaPyCheckFormDataFn(options) {
      if (!this.openService) {
        this.buildFormulaFormErrorListFn();
        return Promise.resolve();
      }
      let loading = dsf.layer.loading()
      const params = await this.$vm.$getSaveParams(options);
      return new Promise((resolve, reject) => {
        dsf.http
          .post("/formula/checkFormData", params, {
            timeout: 60000,
          })
          .done((data) => {
            if (data && data.success) {
              if (data.data?.auditStatus || !data.data?.auditFields?.length) {
                this.buildFormulaFormErrorListFn();
                resolve();
              } else {
                this.buildPyErrorsList(data.data.auditFields);
                this.buildFormulaFormErrorListFn()
                let state = this.checkIsError()
                if (state != 0) {
                  this.open()
                  if (state == 1) {
                    reject('请确认忽略性错误');
                  } else {
                    reject({
                      type: "ValidateError",
                      result: Object.values(this.$vm.$errors),
                      message: "表单校验错误",
                    });
                  }
                } else {
                  resolve();
                }
              }
            } else {
              this.open()
              reject(data);
            }
          })
          .catch((err) => {
            console.error(err);
            this.open()
            reject("Python检测接口错误");
          })
          .finally(() => {
            dsf.layer.closeLoading(loading)
          });
      });
    },
    buildPyErrorsList(list) {
      // console.log(this.$vm.$errors)
      // console.log(list)
      list.forEach((item) => {
        let mandatoryType = item.mandatoryType
        item.id = item.auditId
        item.fields.forEach((table) => {
          let hash;
          if (table.isSubTable) {
            let tableVm = this.$vm.getSubTable(table.tableName)
            if (tableVm) {
              let row = tableVm.value[table.index]
              if (row) hash = row.$hash
            }
          }
          table.fields.forEach((field) => {
            let key = table.tableName + '.' + field
            if (table.isSubTable) {
              key = key + '-' + hash
            }
            let ignore = false
            if (mandatoryType?.value == 4
              || (mandatoryType?.value == 3
                && this.verifyErrorListMap[item.auditId]?.remark
              )) {
              ignore = true
            }
            const opt = {
              formula: item,
              mandatoryType: mandatoryType?.value,
              mandatoryTypeText: mandatoryType?.text,
              ignore, // 忽略型
            }
            this.$vm.pushError(new window.$$ValidateError(item.message, key, opt))
          })
        });
      });
    },
    buildFormulaFormErrorListFn() {
      let errorsList = Object.values(this.$vm.$errors || {});
      console.log(errorsList)
      const verifyErrorListMap = {};
      this.verifyErrorList.forEach((item) => {
        if (item?.info?.formula?.id)
          verifyErrorListMap[item?.info?.formula?.id] = item;
      });
      this.mandatoryErrorList = [];
      this.ignoreErrorList = [];
      this.verifyErrorList = [];
      const subTableRowMap = {};
      if (errorsList.length) {
        errorsList.forEach((arr) => {
          arr.forEach((item) => {
            let dict = this.metadataDict[item.target.replace(/\-.*/, "")];
            const inSubTable = dict.inSubTable;
            const error = {
              info: item.info,
              inSubTable,
              subTable: dict.inSubTable?.replace(
                new RegExp(`${this.$vm.nameSpace.replace(/\./g, "_")}_`),
                ""
              ),
              target: item.target,
              label: `${dict ? dict.name : item.target}`,
              message: item.message,
              remark: "",
            };
            if (inSubTable) {
              if (!subTableRowMap[inSubTable]) {
                subTableRowMap[inSubTable] = {};
                this.$vm.$viewData[inSubTable]?.forEach((row) => {
                  subTableRowMap[inSubTable][row.$hash] = row;
                });
              }
              const hash = item.target.split("-")[1];
              if (hash && subTableRowMap[inSubTable][hash]) {
                error.row = subTableRowMap[inSubTable][hash];
                error.rowIndex = subTableRowMap[inSubTable][hash].$index;
              }
            }
            console.log(item)
            const mandatoryType = item?.info?.mandatoryType;
            if (mandatoryType == 3) {
              if (item?.info?.formula?.id) {
                error.rowIndex =
                  verifyErrorListMap[item?.info?.formula?.id]?.rowIndex;
                error.remark =
                  verifyErrorListMap[item?.info?.formula?.id]?.remark;
              }
              this.verifyErrorList.push(error);
            } else if (mandatoryType == 4 || item?.info?.ignore) {
              this.ignoreErrorList.push(error);
            } else {
              this.mandatoryErrorList.push(error);
            }
          });
        });
      }
      this.emitValueChange(
        JSON.stringify({
          ignoreErrorList: this.ignoreErrorList,
          verifyErrorList: this.verifyErrorList,
          mandatoryErrorList: this.mandatoryErrorList,
        })
      );
    },
    getSubTableLabel(item) {
      if (!item.inSubTable) return "";
      return `[${item.subTable}][${item.rowIndex + 1}]`;
    },
    getRemark(item) {
      return this.verifyErrorListMap[item?.info?.formula?.id]?.remark || "";
    },
    remarkInput(v, item) {
      this.$set(this.verifyErrorListMap[item?.info?.formula?.id], "remark", v);
    },
    errorClick(ite) {
      this.$form.$scrollToError(ite);
      setTimeout(() => {
        clearTimeout(this.stopRemoveClass);
        $(".ds-form-item-audit-state-foucs").removeClass(
          "ds-form-item-audit-state-foucs"
        );
        $(`[form-name="${ite.target}"]`).addClass(
          "ds-form-item-audit-state-foucs"
        );
        this.stopRemoveClass = setTimeout(() => {
          $(`[form-name="${ite.target}"]`).removeClass(
            "ds-form-item-audit-state-foucs"
          );
        }, 400);
      }, 600)
    },
    drawerClose() {
      $(".ds-form-item-audit-state-foucs").removeClass(
        "ds-form-item-audit-state-foucs"
      );
      this.drawerOpen = false;
    },
    open() {
      this.buildFormulaFormErrorListFn();
      if (this.showOpenBtn) {
        this.drawerOpen = true;
      }
      this.$nextTick(() => {
        $('.ds-dm-reportform').each((i, el) => {
          el?.__vue__?.resize()
        })
      })
    },
    showDrawerOpen() {
      this.buildFormulaFormErrorListFn();
      this.drawerOpen = true;
      this.$nextTick(() => {
        $('.ds-dm-reportform').each((i, el) => {
          el?.__vue__?.resize()
        })
      })
    },
    initEvJs() {
      let path = getModuleName("ev", this.$vm.nameSpace, this.$vm.pageName);
      path = dsf.config.serverCreateHtmlDir + path;
      if (this.customEvJsPath) {
        path = this.customEvJsPath;
      }
      dsf.require(
        {
          urlArgs: "_t=" + new Date().getTime(),
        },
        [path],
        (ev) => {
          if (ev && ev.jsFormulaList) {
            this.jsFormulaList = ev.jsFormulaList;
            this.$vm.getFormulaVerifyFn = this.getFormulaVerifyFn;
          }
          this.initJsFormulaLsit = true;
        }
      );
    },
    async save() {
      this.buildFormulaFormErrorListFn()
      if (!this.isSaveAfter && this.drawerOpen) {
        this.isSaveAfter = true
        this.$vm.$once('saveAfter', () => {
          this.isSaveAfter = false
          this.drawerClose()
        })
      }
      this.$vm.formSave({
        isSkipIgnore: true
      });
    },
  },
  created() {
    if (this.$vm && !this.isDesign) {
      this.$vm.formulaPyCheckFormDataFn = this.formulaPyCheckFormDataFn;
      this.initEvJs();
    }
  },
  mounted() {
    this.$vm?.$on("open-audit-state", this.open);
  },
  destroy() {
    this.$vm?.$off("open-audit-state", this.open);
  },
};

function getModuleName(client, ns, pn) {
  let info = splitNameSpace(ns);
  return (client + "/" + info.path + "/" + pn + ".ev.js").replace(
    /(\/\/)/g,
    "/"
  );
}
//切割nameSpace
function splitNameSpace(nameSpace) {
  if (nameSpace.startsWith(".")) {
    nameSpace = nameSpace.substr(1);
  }
  let arr = nameSpace.split(".");
  let fileName = arr[arr.length - 1];
  let path = arr.slice(0, arr.length).join(".");
  let ns = arr.slice(0, arr.length - 1).join(".");
  return {
    path: path,
    file: fileName,
    ns: ns,
  };
}
